import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareCapacityClassicCustomEmbedRoute: InvariantJiraRoute = {
	name: 'software-capacity-classic-custom-embed',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/capacity/:itemId/embed',
};
